
export const loadingMessages = [
  "Analyzing your surgical markings...",
  "Examining measurements and angles...",
  "Reviewing anatomical proportions...",
  "Getting expert feedback..."
] as const;
